import { createSlice } from "@reduxjs/toolkit";
import { AddCPU, UpdateCPU, GetCPUList } from "services/other/cpu.service";
import { toast } from 'react-toastify';

export const cpuAddSlice = createSlice({
  name: "cpuAdd",
  initialState: {
    cpuAdd: {},
    cpuAddLoading: false,
    cpuAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddCPU.pending, (state) => {
      // toast.loading('We are adding the cpu 🤯')
      state.cpuAddLoading = true
    });

    builder.addCase(AddCPU.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New cpu added successfully 👌');

      state.cpuAdd = action.payload
      state.cpuAddLoading = false
      state.cpuAddError = null
    });

    builder.addCase(AddCPU.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the cpu 😣")

      state.cpuAddLoading = false
      state.cpuAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const cpuUpdateSlice = createSlice({
  name: "cpuUpdate",
  initialState: {
    cpuUpdate: {},
    cpuUpdateLoading: false,
    cpuUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateCPU.pending, (state) => {
      // toast.loading('We are updating the cpu 🤯')
      state.cpuUpdateLoading = true
    });

    builder.addCase(UpdateCPU.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.cpuUpdate = action.payload
      state.cpuUpdateLoading = false
      state.cpuUpdateError = null
    });

    builder.addCase(UpdateCPU.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the cpu 😣")

      state.cpuUpdateLoading = false
      state.cpuUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const cpuListSlice = createSlice({
  name: "cpuList",
  initialState: {
    cpuList: [],
    cpuListLoading: false,
    cpuListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetCPUList.pending, (state) => {
      state.cpuListLoading = true
    });

    builder.addCase(GetCPUList.fulfilled, (state, action) => {
      toast.dismiss();

      state.cpuList = action.payload
      state.cpuListLoading = false
      state.cpuListError = null
    });

    builder.addCase(GetCPUList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the cpu 😣")

      state.cpuListLoading = false
      state.cpuListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});